import { ArrowLeft } from 'lucide-react';

export const BackButton = ({
  onClick,
  ...props
}: { onClick: () => void } & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      {...props}
      onClick={onClick}
      className="flex h-6 w-6 cursor-pointer items-center justify-center gap-2 rounded-full border bg-gray-100 hover:bg-gray-200"
    >
      <ArrowLeft className="h-4 w-4" />
    </button>
  );
};
